import { render, staticRenderFns } from "./LightBoxBody.vue?vue&type=template&id=43e4d544&scoped=true&"
import script from "./LightBoxBody.vue?vue&type=script&lang=js&"
export * from "./LightBoxBody.vue?vue&type=script&lang=js&"
import style0 from "./LightBoxBody.vue?vue&type=style&index=0&id=43e4d544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e4d544",
  null
  
)

export default component.exports